import api from "./api";

const http = {
  get: async (url, config = {}) => {
    const res = await api.get(url, config);
    return res.data;
  },

   post: async (url, data, config = {}) => {
    const res = await api.post(url, data, {
      withCredentials: false, // for cookies
      ...config,
    });
    return res.data;
  },

  put: async (url, data, config = {}) => {
    const res = await api.put(url, data, config);
    return res.data;
  },

  patch: async (url, data, config = {}) => {
    const res = await api.patch(url, data, config);
    return res.data;
  },

  delete: async (url, config = {}) => {
    const res = await api.delete(url, config);
    return res.data;
  },
};

export default http;
 